import { useMemo } from "react";

import { useApiQuery } from "app/modules/api-client";

import { useActivationSet } from "../../../hooks/useActivationSet";
import { useActivationSetFavicons } from "../../../hooks/useActivationSetFavicons";
import { useCommonAlertsQueryParams } from "../../useCommonAlertsQueryParams";
import { useNewsAlertsFilterStore } from "../filters/useNewsAlertsFilterStore";
import { transformNewsMetricsData } from "../utils/transformNewsMetricsData";

export const useNewsMetricsData = () => {
    const selectedTopics = useNewsAlertsFilterStore((s) => s.selectedTopics);
    const isDefaultTopicsSelected = useNewsAlertsFilterStore((s) => s.isDefaultTopicsSelected);
    const params = useCommonAlertsQueryParams();
    const { activationSet, isLoading: isActivationSetLoading } = useActivationSet();
    const { favicons, isLoading: isFaviconsLoading } = useActivationSetFavicons();

    const topics = useMemo(
        () => (isDefaultTopicsSelected ? undefined : Array.from(selectedTopics.keys())),
        [isDefaultTopicsSelected, selectedTopics],
    );

    const { data, isLoading: isDataLoading } = useApiQuery(
        {
            tag: "Alerts",
            methodName: "activationAlertsMetricsNewsDetail",
            options: {
                refetchOnMount: true,
            },
        },
        {
            ...params,
            topics,
        },
    );

    const transformedData = useMemo(() => {
        if (!data) {
            return [];
        }

        return transformNewsMetricsData({
            data,
            icons: favicons,
            primaryDomain: activationSet?.primaryDomain,
        });
    }, [activationSet?.primaryDomain, favicons, data]);

    return {
        data: transformedData,
        isLoading: isActivationSetLoading || isDataLoading || isFaviconsLoading,
    };
};
